import { DomainError } from '../../shared/errors/domain-error';

export class AuthenticationError extends DomainError {
  readonly code = 'AUTHENTICATION_ERROR' as const;

  constructor(
    message: string = 'Authentication failed.',
    originalError?: unknown,
  ) {
    super(message, originalError);
  }
}
